/**
 */

/* 是否是公司邮箱*/
export function isWscnEmail(str) {
  const reg = /^[a-z0-9](?:[-_.+]?[a-z0-9]+)*@wz\.com$/i;
  return reg.test(str.trim());
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 验证key*/
// export function validateKey(str) {
//     var reg = /^[a-z_\-:]+$/;
//     return reg.test(str);
// }

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

export function oneOf (value, validList) {
    for (let i = 0; i < validList.length; i++) {
        if (value === validList[i]) {
            return true;
        }
    }
    return false;
}

export function SortByKey(ary, key) {
    return ary.sort(function (a, b) {
        let x = a[key]
        let y = b[key]
        return ((x < y) ? -1 : (x > y) ? 1 : 0)
    })
}

export function DeleteByKey(ary, key) {
    const result = ary.filter(route => {
        if(route == key){
            return false;
        }
        return true;
    });
    return result;
}

export function DeleteByType(ary, key) {
    const result = ary.filter(route => {
        if(route.type == key){
            return false;
        }
        return true;
    });
    return result;
}

export function formatProvinceName(name) {
    if (name === undefined || name === null || name === '') {
        return '-：';
    }
    if (name.startsWith('内蒙古')) {
        return '内蒙古：';
    }
    if (name.startsWith('西藏')) {
        return '西藏：';
    }
    if (name.startsWith('宁夏')) {
        return '宁夏：';
    }
    if (name.startsWith('新疆')) {
        return '新疆：';
    }
    if (name.startsWith('广西')) {
        return '广西：';
    }
    return name + '：';
}

export function formatProvinceName1(name) {
    if (name === undefined || name === null || name === '') {
        return '-';
    }
    if (name.startsWith('内蒙古')) {
        return '内蒙古';
    }
    if (name.startsWith('西藏')) {
        return '西藏';
    }
    if (name.startsWith('宁夏')) {
        return '宁夏';
    }
    if (name.startsWith('新疆')) {
        return '新疆';
    }
    if (name.startsWith('广西')) {
        return '广西';
    }
    return name;
}






// WEBPACK FOOTER //
// ./src/utils/validate.js